<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="date"
      size="small"
      type="year"
      value-format="yyyy-MM-dd"
      style="width: 100px;"
      :clearable="false"
      @change="dateChange"
    >
    </el-date-picker>

    <el-radio-group v-model="query.isSiteMerge" size="small" @change="getData">
      <el-radio-button :label="true">聚合数据</el-radio-button>
      <el-radio-button :label="false">站点数据</el-radio-button>
    </el-radio-group>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <sidebar-content sidebarWidth="180px" title="站点选择">
      <template #silder-header-toolbar>
        <select-ctrl-group
          :ids="query.siteIds"
          :options="filterSites"
          show-icon
          style="padding-bottom:0;"
          @change="onSelectCtrlChange"
        />
      </template>

      <template #sidebar-body>
        <div class="device-dropdown-selector-wrapper">
          <div class="device-dropdown-selector-wrapper-inner">
            <el-tree
              ref="site-tree"
              :data="filterSites"
              :props="{
                value: 'id',
                label: 'name'
              }"
              node-key="id"
              show-checkbox
              accordion
              check-on-click-node
              :default-checked-keys="query.siteIds"
              @check="onSiteCheckChange"
            />
            <!-- <div
              v-for="site in filterSites"
              :key="site.id"
              class="device-dropdown-selector"
            >
              <el-checkbox v-model="query.siteIds" :label="site.id" @change="setQuerySite">{{site.name}}</el-checkbox>
            </div> -->
          </div>
        </div>
      </template>

      <template #sidebar-content-body>
        <div
          :ref="query.isSiteMerge ? 'contentBody' : ''"
          :style="{width: '100%', height: '100%', padding: '3px', overflow: `${query.isSiteMerge ? 'hidden auto' : ''}`}"
        >
          <div :style="{width: `${clientWidth}px`, height: `${(calendarChartH - 10) * calendarChartRow + 100}px`}" v-if="query.isSiteMerge">
            <a-q-i-pollute-analysis
              ref="charts"
              :data="chartDatas"
              :screen-width="clientWidth"
              :screen-height="clientHeight"
              :query="query"
            />
          </div>
          <div style="width: 100%;height: 100%;" v-if="!query.isSiteMerge">
            <section class="data-wrapper">
              <div class="site-charts-title" >
                <h3>{{date}}年污染日历图（色阶为AQI）</h3>
                <div class="charts-legend">
                  <span>
                    <i style="background: #0EEE07;"></i>
                    0-50
                  </span>
                  <span>
                    <i style="background: #FEC329;"></i>
                    50-100
                  </span>
                  <span>
                    <i style="background: #ED781F;"></i>
                    100-150
                  </span>
                  <span>
                    <i style="background: #ED0300;"></i>
                    150-200
                  </span>
                  <span>
                    <i style="background: #8B465D;"></i>
                    200-300
                  </span>
                  <span>
                    <i style="background: #A52A29;"></i>
                    >300
                  </span>
                </div>
              </div>
              <section
                class="site-data"
                :ref="!query.isSiteMerge ? 'contentBody' : ''"
              >
                <div
                  :style="{width: `${clientWidth / dataList.length}px`, height: `${calendarChartH * calendarChartRow + (query.isSiteMerge ? 100 : 50)}px`}"
                  v-for="(el, index) in dataList"
                  :key="index"
                >
                  <div class="site-data-header">
                    <span>{{el.name}}</span>
                  </div>
                  <div class="site-data-body">
                    <div :style="{width: '100%', height: '100%'}">
                      <a-q-i-pollute-analysis
                        ref="charts"
                        :data="el.data"
                        :screen-width="clientWidth"
                        :screen-height="clientHeight"
                        :query="query"
                      />
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </div>
        </div>
      </template>
    </sidebar-content>
  </template>
</layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import AQIPolluteAnalysis from '../../../../components/Data/AQIPolluteAnalysis'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'StatisticalAnalysisAQIPollutantCalendar',
  routeInfo: {
    label: '污染日历图'
  },
  extends: BaseFactorData,
  components: {LayoutContent, AQIPolluteAnalysis},
  data () {
    return {
      date: new Date().format('YYYY-MM-DD'),
      query: {
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        granularity: 24,
        isAuditCompleted: false, // finished
        isSiteMerge: true,
        isTimeMerge: false
      },
      flag: {
        merge: true,
        site: false
      },
      activeName: 'merge',
      chartDatas: [],
      dataList: [],
      clientWidth: 0,
      clientHeight: 0,
      calendarChartH: 0,
      calendarChartRow: 0
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    setActive () {
      this.activeName = 'merge'
      this.query.isSiteMerge = true
      this.getData()
    },
    setQuerySite (el) {
      if (this.query.siteIds.length > 4) {
        this.query.siteIds = this.query.siteIds.splice(0, 4)
        return
      }
      if (this.query.siteIds.length <= 4) {
        this.getData()
      }
    },
    handleChange (el) {
      if (el !== '') {
        this.query.isSiteMerge = !this.query.isSiteMerge
        this.getData()
      }
    },
    dateChange (date) {
      this.query.beginTime = new Date(date).format('YYYY/01/01 00:00:00')
      this.query.endTime = new Date(date).format('YYYY/12/31 23:59:59')
      this.getData()
    },
    handleClick (tab, event) {
      let {flag} = this
      this.query.isSiteMerge = flag[tab.name]
      this.getData()
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    getData () {
      this.changeLoadStatus(true)
      this.dataTableKey = 0
      let {query} = this
      if (query.siteIds.length === 0) {
        this.dataList = []
        this.chartDatas = []
        this.renderData()
        this.changeLoadStatus(false)
        return false
      }
      this.$api.Aqi.getAQIData(query).then(backData => {
        if (backData.length === 0) {
          if (!query.isSiteMerge) {
            this.dataList = query.siteIds.map(el => {
              return {
                name: this.filterSiteMap[el].name,
                date: this.date,
                data: []
              }
            })
          } else {
            this.chartDatas = []
          }
          this.renderData()
          return false
        }

        let dataArr = backData.map(item => {
          item.aqi = item.hasOwnProperty('aqi') ? Number(item.aqi).toFixed(2) : '--'

          return {...item}
        })

        if (query.isSiteMerge === false) {
          let {filterSiteMap} = this
          this.csvData = dataArr.map(item => {
            return {
              ...filterSiteMap[item.siteId],
              ...item
            }
          })

          let temp = query.siteIds.reduce((map, el) => {
            if (!map[el]) {
              map[el] = {
                id: el,
                data: []
              }
            }

            dataArr.forEach(item => {
              if (el === item.siteId) {
                item.primaryPollutant = item.primaryPollutant.replace('H8O3', 'O3')
                map[el].data.push(item)
              }
            })

            return map
          }, {})

          dataArr = Object.values(temp).map(item => {
            return {
              ...filterSiteMap[item.id],
              data: Object.values(item.data)
            }
          })
        }

        this.formatData(dataArr)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
        this.windowRize()
      })
    },
    getDataRenders () {
      return Array.isArray(this.$refs['charts']) ? this.$refs['charts'] : [this.$refs['charts']]
    },
    formatData (data) {
      let {query: {beginTime, endTime, isSiteMerge, granularity}} = this
      let beginTS = new Date(beginTime).getTime()
      let endTS = new Date(endTime).getTime()
      let tsStep = granularity * 60 * 60000
      let dateData = {}

      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        dateData[ts] = {
          dataTime: new Date(ts).format('YYYY-MM-DD')
        }
      }

      let chartDatas = {}
      if (isSiteMerge) {
        data.forEach(el => {
          let {dataTime} = el
          let ts = new Date(dataTime).getTime()

          dateData[ts] = el
        })

        chartDatas = Object.values(dateData).reduce((map, el) => {
          let month = new Date(el.dataTime).format('YYYY-MM')

          if (el.hasOwnProperty('primaryPollutant')) {
            el.primaryPollutant = el.primaryPollutant.replace('H8O3', 'O3')
          }
          if (!map[month]) {
            map[month] = {
              month: month,
              data: [],
              heatmapData: [],
              lunarData: []
            }
          }
          map[month].data.push(el)
          map[month].heatmapData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.hasOwnProperty('aqi') ? Number(el.aqi).toFixed(2) : null])
          map[month].lunarData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.hasOwnProperty('aqi') ? Number(el.aqi).toFixed(2) : null, el.hasOwnProperty('primaryPollutant') ? el.primaryPollutant : '--'])
          return map
        }, {})

        this.chartDatas = Object.values(chartDatas)
      } else {
        for (let i = 0; i < data.length; i++) {
          let temp = data[i]

          if (temp.data.length === 0) {
            continue
          }

          temp.data.forEach(el => {
            let {dataTime} = el
            let ts = new Date(dataTime).getTime()

            dateData[ts] = el
          })

          data[i].data = Object.values(Object.values(dateData).reduce((map, el) => {
            let month = new Date(el.dataTime).format('YYYY-MM')
            if (!map[month]) {
              map[month] = {
                month: month,
                data: [],
                heatmapData: [],
                lunarData: []
              }
            }
            map[month].data.push(el)
            map[month].heatmapData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.aqi ? Number(el.aqi).toFixed(2) : null])
            map[month].lunarData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.aqi ? Number(el.aqi).toFixed(2) : null, el.primaryPollutant ? el.primaryPollutant : '--'])
            return map
          }, {}))
        }

        this.dataList = data
      }
    },
    getHR () {
      let {clientWidth, clientHeight, query: {isSiteMerge, siteIds}} = this
      let defaultWidth = 300

      let width = clientWidth - 60
      if (!isSiteMerge) {
        width = (clientWidth / siteIds.length) - 60
      }
      let height = clientHeight - (isSiteMerge ? 100 : 50)
      let computedW = width / defaultWidth

      let col = computedW > 0 && Math.floor(computedW) <= 1 ? 1 : Math.floor(computedW)
      if (col > 4) {
        col = 4
      }
      let row = 12 / col
      let h = Math.floor(height / row)
      // let w = Math.floor(width / col)

      this.calendarChartH = h < 220 ? 250 : h
      this.calendarChartRow = row
    },
    windowRize () {
      let contentBody = this.$refs.contentBody
      let clientHeight = contentBody.clientHeight
      let clientWidth = contentBody.clientWidth
      this.clientHeight = clientHeight
      this.clientWidth = clientWidth

      this.getHR()
      setTimeout(() => {
        this.renderData()
      }, 0)
    },
    onSiteCheckChange () {
      let checkedSiteList = this.getSiteTree().getCheckedNodes()
      this.query.siteIds = checkedSiteList.filter(item => !Array.isArray(item.children)).map(item => item.id)
      this.getData()
    },
    setCheckedKeys (siteIds) {
      let factorTree = this.getSiteTree()

      if (factorTree) {
        factorTree.setCheckedKeys(siteIds)
        this.getData()
      }
    },
    getSiteTree () {
      return this.$refs['site-tree']
    },
    onSelectCtrlChange (ids) {
      this.setCheckedKeys(ids)
    }
  },
  created () {
    window.addEventListener('resize', this.windowRize)
    let dateObj = new Date()
    let y = dateObj.getFullYear()
    this.query.beginTime = new Date().format('YYYY/01/01 00:00:00')
    this.query.endTime = new Date(y, 12, 0).format('YYYY/12/DD 23:59:59')
    delete this.query.dataType
    this.getData()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowRize)
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

.tree-popover-wrapper {
  max-height: 300px;
  overflow: auto;
}

.data-wrapper {
  position: relative;
  height: 100%;

  .site-data {
    position: absolute;
    top: 60px;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    overflow: hidden auto;
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    width: 100%;
    height: 100%;
  }
}
/deep/ .el-tabs--left {
  height: 100% !important;
}
/deep/ .el-tabs__content {
  height: 100%;
  overflow: auto;
}
/deep/ #pane-merge {
  height: 100%;
}
.device-dropdown-selector-wrapper {
  display: grid;
  grid-template-rows: 100%;
  height: 400px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px 0;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}
.site-charts-title {
  width: 100%;
  height: 60px;

  h3 {
    margin: 2px 0;
    text-align: center;
  }

  >.charts-legend {
    text-align: center;
    margin: 3px 0 7px 0;

    > span {
      display: inline-block;
      height: 13px;
      line-height: 13px;

      > i {
        display: inline-block;
        width: 20px;
        height: 100%;
        margin: 0 5px 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/05Pollutant-Analysis/index.vue